const organizations = {
    title: '組織',
    description: '所属する組織を作成・管理します。',
    create: '組織を作成',
    create_title: '新しい組織を作成',
    name: '組織名',
    avatar: '組織のアバター',
    avatar_removed: '組織のアバターを削除しました。',
    description_label: '説明',
    empty: 'まだ組織に所属していません。',
    pending_invitations: '保留中の招待',
    accept: '承諾',
    decline: '辞退',
    owner: '所有者',
    tabs: {
        overview: '概要',
        members: 'メンバー',
        invitations: '招待',
        roles: '管理ロール',
        branding: 'ブランド',
        security: 'セキュリティ',
        jit: 'JIT プロビジョニング',
        applications: '共有リソース',
        activity: 'アクティビティ',
        deletion: '削除',
    },
    members: {
        title: 'メンバー',
        empty: 'メンバーはいません。',
        remove: '削除',
        removed: 'メンバーを削除しました。',
        business_roles: '業務ロール',
        no_business_roles: '利用可能な業務ロールがありません。テナント管理者にこの組織へのロールの共有を依頼してください。',
    },
    invitations: {
        title: '招待',
        invite: 'メンバーを招待',
        email: 'メールアドレス',
        empty: '招待はありません。',
        resend: '再送信',
        resent: '招待を再送信しました。',
        revoke: '取り消し',
        revoked: '招待を取り消しました。',
        status: {
            Pending: '保留中',
            Accepted: '承諾済み',
            Expired: '期限切れ',
            Revoked: '取り消し済み',
            Declined: '辞退済み',
        },
    },
    roles: {
        title: '管理ロール',
        create: 'ロールを作成',
        permissions: '権限',
        empty: '管理ロールはありません。',
        select_member: 'メンバーを選択',
        select_role: 'ロールを選択',
        assign: 'ロールを割り当て',
        assigned: 'ロールを割り当てました。',
        unassign: 'ロールを解除',
        unassigned: 'ロールを解除しました。',
        permission_count: '権限数：{{count}}',
        built_in: {
            owner: '所有者',
            owner_description: '所有権の管理と組織の削除に関する専用の権限を持ちます。',
            administrator: '管理者',
            administrator_description: '所有者専用の操作を除いて組織を管理します。',
        },
        permission_labels: {
            update_profile: '組織情報を更新',
            manage_branding: 'ブランドを管理',
            view_members: 'メンバーを表示',
            manage_members: 'メンバーを管理',
            manage_invitations: '招待を管理',
            assign_business_roles: '業務ロールを割り当て',
            manage_management_roles: '管理ロールを管理',
            assign_management_roles: '管理ロールを割り当て',
            manage_security: 'セキュリティを管理',
            manage_jit: 'JIT プロビジョニングを管理',
            manage_applications: 'アプリを管理',
            view_activity: 'アクティビティを表示',
        },
    },
    branding: {
        title: '組織のブランド',
        primary_color: 'メインカラー',
        custom_css: 'カスタム CSS',
        preview: 'プレビュー',
        light: 'ライト',
        dark: 'ダーク',
    },
    security: {
        title: '組織のセキュリティ',
        require_mfa: 'メンバーに多要素認証を必須にする',
    },
    jit: {
        title: 'JIT メールドメイン',
        domain: 'メールドメイン',
        add: 'ドメインを追加',
        verify: 'DNS を確認',
        dns_instruction: 'TXT レコード {{record}} を値 {{value}} で作成してください。',
        verified: '確認済み',
    },
    applications: {
        title: '共有リソース',
        empty: 'この組織で利用可能なリソースはありません。',
        sso: '企業 SSO 接続',
        m2m: 'マシン間アプリ',
    },
    activity: {
        title: '組織のアクティビティ',
        empty: 'アクティビティはありません。',
        events: {
            create: '組織を作成',
            delete: '組織を削除',
            profile: '組織情報を更新',
            branding: '組織のブランドを更新',
            security: '組織のセキュリティを更新',
            member_add: 'メンバーを追加',
            member_remove: 'メンバーを削除',
            owner: '組織の所有権を変更',
            role_create: '管理ロールを作成',
            role_update: '管理ロールを更新',
            role_delete: '管理ロールを削除',
            role_assign: '管理ロールを割り当て',
            role_unassign: 'メンバーの管理ロールを解除',
            business_role: '業務ロールを更新',
            invitation_create: '招待を送信',
            invitation_accept: '招待を承諾',
            invitation_decline: '招待を辞退',
            invitation_revoke: '招待を取り消し',
            jit: 'JIT プロビジョニングを更新',
            domain: 'メールドメインの確認',
            application: 'アプリの関連付けを更新',
            unknown: '組織のアクティビティ',
        },
    },
    save: '変更を保存',
    cancel: 'キャンセル',
    delete: '組織を削除',
    delete_confirmation: '組織とそのメンバーシップを完全に削除します。「{{name}}」を入力して確認してください。',
    deleted: '組織を削除しました。',
    load_failed: '組織データを読み込めませんでした。再試行してください。',
    permission_denied: 'このセクションを表示する権限がありません。',
};
export default organizations;
